import React from 'react';
import { TelephoneState } from '../TelephoneButton';
import { TelephoneButtonWithAlert } from '../TelephoneButtonWithAlert';
import { TelephonePopoverButton } from '../TelephonePopoverButton';

type Props = {
    telephones: Record<string, TelephoneState>;
    onClick?: (tag: string) => void;
}

export const TelephonePanel = ({ onClick, telephones }: Props) => {
    const tags = Object.keys(telephones);
    return (
        <>
            {tags.length === 1 ?
                <TelephoneButtonWithAlert
                    tag={tags[0]}
                    state={telephones[tags[0]]}
                    onClick={onClick && (() => onClick(tags[0]))}
                />
                :
                <TelephonePopoverButton
                    state={telephones}
                    onClick={onClick}
                />
            }
        </>
    );
};